import { c as _c } from "react/compiler-runtime";
import { Divider, Stack, Typography } from '@mui/material';
import type { Provider, ResourceType } from '@repo/api-gw-sdk';
import { useState } from 'react';
import { pluralize } from '@/utils/string';
import { useDebouncedValue } from '@/utils/useDebouncedValue';
import { ResourcesSelectorAccordion } from './resourcesSelector';
import { useResourceIdentifiers } from '../queryBuilder/useResourceIentifiers';
export const ResourceSelectionManualOverridesEditor = t0 => {
  const $ = _c(46);
  const {
    description,
    includeResources,
    excludeResources,
    setIncludedResources,
    setExcludedResources,
    supportedProviders,
    supportedResourceTypes
  } = t0;
  const [includeFilter, setIncludeFilter] = useState("");
  const [excludeFilter, setExcludeFilter] = useState("");
  const debouncedIncludeFilter = useDebouncedValue(includeFilter, 300);
  const debouncedExcludeFilter = useDebouncedValue(excludeFilter, 300);
  const {
    data: allResourcesData
  } = useResourceIdentifiers(supportedProviders, supportedResourceTypes);
  const {
    data: includeResourcesData
  } = useResourceIdentifiers(supportedProviders, supportedResourceTypes, debouncedIncludeFilter || undefined);
  const {
    data: excludeResourcesData
  } = useResourceIdentifiers(supportedProviders, supportedResourceTypes, debouncedExcludeFilter || undefined);
  let t1;
  if ($[0] !== allResourcesData?.resources) {
    t1 = allResourcesData?.resources ?? [];
    $[0] = allResourcesData?.resources;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const allResources = t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      gap: "32px",
      width: "308px"
    };
    t3 = <Typography variant="h3">Manual overrides</Typography>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      gap: "24px",
      overflow: "auto"
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== description) {
    t5 = <Typography variant="body1">{description}</Typography>;
    $[5] = description;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      gap: "12px"
    };
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = includeResources.length;
  let t8;
  if ($[8] !== includeResources.length) {
    t8 = pluralize("resource", includeResources.length);
    $[8] = includeResources.length;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const t9 = `${t7} ${t8} manually included${includeResources.length ? ":" : "."}`;
  let t10;
  if ($[10] !== includeResourcesData?.resources) {
    t10 = includeResourcesData?.resources ?? [];
    $[10] = includeResourcesData?.resources;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  let t12;
  if ($[12] !== includeResources || $[13] !== setIncludedResources) {
    t11 = resource => setIncludedResources([...includeResources, resource]);
    t12 = resource_0 => setIncludedResources(includeResources.filter(r => r !== resource_0));
    $[12] = includeResources;
    $[13] = setIncludedResources;
    $[14] = t11;
    $[15] = t12;
  } else {
    t11 = $[14];
    t12 = $[15];
  }
  let t13;
  if ($[16] !== allResources || $[17] !== includeResources || $[18] !== t10 || $[19] !== t11 || $[20] !== t12 || $[21] !== t9) {
    t13 = <ResourcesSelectorAccordion label="Included resources" description={t9} allResources={allResources} filteredResources={t10} resources={includeResources} onFilterChange={setIncludeFilter} addResource={t11} removeResource={t12} />;
    $[16] = allResources;
    $[17] = includeResources;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
    $[21] = t9;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Divider />;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  const t15 = excludeResources.length;
  let t16;
  if ($[24] !== excludeResources.length) {
    t16 = pluralize("resource", excludeResources.length);
    $[24] = excludeResources.length;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  const t17 = `${t15} ${t16} manually excluded:`;
  let t18;
  if ($[26] !== excludeResourcesData?.resources) {
    t18 = excludeResourcesData?.resources ?? [];
    $[26] = excludeResourcesData?.resources;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  let t20;
  if ($[28] !== excludeResources || $[29] !== setExcludedResources) {
    t19 = resource_1 => setExcludedResources([...excludeResources, resource_1]);
    t20 = resource_2 => setExcludedResources(excludeResources.filter(r_0 => r_0 !== resource_2));
    $[28] = excludeResources;
    $[29] = setExcludedResources;
    $[30] = t19;
    $[31] = t20;
  } else {
    t19 = $[30];
    t20 = $[31];
  }
  let t21;
  if ($[32] !== allResources || $[33] !== excludeResources || $[34] !== t17 || $[35] !== t18 || $[36] !== t19 || $[37] !== t20) {
    t21 = <ResourcesSelectorAccordion label="Excluded resources" description={t17} allResources={allResources} filteredResources={t18} resources={excludeResources} onFilterChange={setExcludeFilter} addResource={t19} removeResource={t20} />;
    $[32] = allResources;
    $[33] = excludeResources;
    $[34] = t17;
    $[35] = t18;
    $[36] = t19;
    $[37] = t20;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <Divider />;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== t13 || $[41] !== t21) {
    t23 = <Stack sx={t6}>{t13}{t14}{t21}{t22}</Stack>;
    $[40] = t13;
    $[41] = t21;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  let t24;
  if ($[43] !== t23 || $[44] !== t5) {
    t24 = <Stack sx={t2}>{t3}<Stack sx={t4}>{t5}{t23}</Stack></Stack>;
    $[43] = t23;
    $[44] = t5;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  return t24;
};